export enum RouteType {
  None,
  New,
  Standard,
  Copy,
}

export enum DefaultRouteType {
  None = -1,
  New = -2,
}
